import { useEffect, useState } from "react";
//import { useStyles } from "../../style";
import { Box, CircularProgress, Dialog, FormControl, Grid, MenuItem, Select, TextField, Typography, Button, Card, IconButton, InputLabel }
    from "@mui/material"; 
import dayjs from "dayjs";
import { getApiUrl } from "../../services/api_service";
import AccessLocalStorage from "../../services/localStorage";
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete'
import { blackcolor, buttonRed, dashboardText, fsSmall, icon34, mainGrid, paddingbox, pcolor } from "../../style2";


export default function VideoList(props) {
    //const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [selectedYear, setSelectYear] = useState(dayjs().year());
    const [selectedMonth, setSelectMonth] = useState(0);
    const [error, setError] = useState(null);
    const [entries, setEntries] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const ls = new AccessLocalStorage();


    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }
        setLoading(true);
        fetch(
            `${getApiUrl()}/record/videos/${ls.getCurrentPatientId()}/${selectedYear}/${selectedMonth}`,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                //console.log(data);
                setEntries(data);
            })
            .catch((err) => {
                setError(err.message || "An error occurred.");
                setEntries([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedYear, selectedMonth]);

    const renderYearOptions = () => {
        let items = [];
        let d = new Date(Date.now());
        for (let i = d.getFullYear(); i > d.getFullYear() - 25; i--) {
            items.push(<MenuItem value={i}>{i}</MenuItem>);
        }
        return items;
    }

    const renderMonthName = () => {
        switch (selectedMonth) {
            case 0:
                return "";
            case 1:
                return "Jan ";
            case 2:
                return "Feb ";
            case 3:
                return "Mar ";
            case 4:
                return "Apr ";
            case 5:
                return "May ";
            case 6:
                return "Jun ";
            case 7:
                return "Jul";
            case 8:
                return "Aug ";
            case 9:
                return "Sep ";
            case 10:
                return "Oct ";
            case 11:
                return "Nov ";
            case 12:
                return "Dec ";

        }
    }
    return (
        <>
            <Box sx={paddingbox}>
                <Grid container>
                    <Grid item xs={12} container>
                        <Grid item xs={8}>
                            <Box display="flex" alignItems="center" sx={dashboardText}>
                                <Box component="img" src="assets/video.png" sx={icon34}></Box> <Box mr={1} /> Video Timeline - {renderMonthName()}{selectedYear}
                                {loading ? <span style={{ marginLeft: 10 }}><CircularProgress size={20} /></span> : null}
                            </Box>

                        </Grid>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 120, paddingRight: 1 }} size="small">
                                <InputLabel id="video-month-select-label">Month</InputLabel>
                                <Select disabled={loading} labelId="video-month-select-label"
                                    id="video-month-select" value={selectedMonth} label="Month" onChange={(event) => { setSelectMonth(event.target.value); }}>
                                    <MenuItem value={0}>Month</MenuItem>
                                    <MenuItem value={1}>Jan</MenuItem>
                                    <MenuItem value={2}>Feb</MenuItem>
                                    <MenuItem value={3}>Mar</MenuItem>
                                    <MenuItem value={4}>Apr</MenuItem>
                                    <MenuItem value={5}>May</MenuItem>
                                    <MenuItem value={6}>Jun</MenuItem>
                                    <MenuItem value={7}>Jul</MenuItem>
                                    <MenuItem value={8}>Aug</MenuItem>
                                    <MenuItem value={9}>Sep</MenuItem>
                                    <MenuItem value={10}>Oct</MenuItem>
                                    <MenuItem value={11}>Nov</MenuItem>
                                    <MenuItem value={12}>Dec</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 120 }} size="small">
                                <InputLabel id="video-year-select-label">Year</InputLabel>
                                <Select disabled={loading} labelId="video-year-select-label"
                                    id="video-year-select" value={selectedYear} label="Year" onChange={(event) => { setSelectYear(event.target.value); }}>
                                    {renderYearOptions()}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Box m={1} />
                    <Grid item xs={12}>
                        <Box sx={{ ...mainGrid, padding: "20px", overflowX: "auto", overflowY: "hidden" }}>
                            {entries.length > 0 ? <table cellPadding={0} cellSpacing={0} >
                                <tbody>
                                    <tr>
                                        {entries.map(v => {
                                            return <td align="center" valign="middle" style={{ padding: "20px 20px 0px 5px", cursor: "pointer" }} onClick={() => { setSelectedVideo(v); }} >
                                                <video title={`${v.type} video file ${v.displayName}`} style={{ width: "180px", height: "120px", background: "rgba(255,255,255)", borderRadius: 10 }} src={v.s3TempPath}>
                                                </video>
                                                <Typography style={{ fontSize: "0.965rem" }}>{v.displayName}</Typography>
                                                <Typography style={{ fontSize: "0.965rem" }}>{dayjs(v.createdAt).format('DD/MM/YY')}</Typography>
                                            </td>
                                        })}
                                    </tr>
                                </tbody>
                            </table> : null}
                            {entries.length === 0 && !loading ? <Typography>No videos found.</Typography> : null}
                        </Box>
                        {selectedVideo !== null ?
                            <Dialog open={true} onClose={() => { setSelectedVideo(null); }} fullWidth maxWidth={ls.isAdmin() || ls.isPediatrician() ? "xl" : "md"}>
                                <Grid container style={{ backgroundColor: "#545454", color: "#fff", padding: "10px" }}>
                                    <Grid item xs={11} >
                                        <Typography>{selectedVideo.displayName}</Typography>
                                    </Grid>
                                    <Grid item xs={1} style={{ textAlign: "right", cursor: "pointer" }}>
                                        <CloseIcon onClick={() => { setSelectedVideo(null); }} />
                                    </Grid>
                                </Grid>
                                <ShowVideo video={selectedVideo} showNotesForm={ls.isAdmin() || ls.isPediatrician()} />
                            </Dialog> : null}
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

function ShowVideo(props) {
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [error, setError] = useState('');
    const [errorSave, setErrorSave] = useState('');
    //const classes = useStyles();
    const ls = new AccessLocalStorage();
    const [notes, setNotes] = useState([]);


    useEffect(() => {

        setLoading(true);
        fetch(
            `${getApiUrl()}/record/videonotes/${ls.getCurrentPatientId()}?fileName=${props.video.fileName}`,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${ls.getToken()}` },
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    response.json().then(data => { setNotes(data); })
                } else {
                    response.json().then(data => {
                        setError(data.error);
                        //console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    });
                }
            })
            .catch((err) => {
                setError("Unable to contact server.");
                setNotes([]);
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [props]);

    const saveData = () => {
        setLoadingSave(true);
        setErrorSave('');
        fetch(
            `${getApiUrl()}/record/addvideonote/${ls.getCurrentPatientId()}`,
            {
                method: "POST",
                body: JSON.stringify({ fileName: props.video.fileName, note }),
                headers: { Authorization: `Bearer ${ls.getToken()}`, 'content-type': 'application/json' },
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    response.json().then(data => {
                        //console.log(data);
                        setNotes( // Replace the state
                            [ // with a new array
                                data,
                                ...notes // that contains all the old items
                                // and one new item at the end
                            ]
                        );

                    });
                    setNote('');

                } else {
                    response.json().then(data => {
                        setErrorSave(data.error);
                        //console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setErrorSave("Unable to process request.");
                    });
                }
            })
            .catch((err) => {
                setErrorSave("Unable to contact server.");

                console.log(err);
            })
            .finally(() => {
                setLoadingSave(false);
            });
    }

    const removeData = (id) => {
        setLoadingSave(true);
        setErrorSave('');
        fetch(
            `${getApiUrl()}/record/deletevideonote/${id}`,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${ls.getToken()}`, 'content-type': 'application/json' },
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    setNotes(notes.filter(t => t.id !== id));

                } else {
                    response.json().then(data => {
                        setErrorSave(data.error);
                        //console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setErrorSave("Unable to process request.");
                    });
                }
            })
            .catch((err) => {
                setErrorSave("Unable to contact server.");

                console.log(err);
            })
            .finally(() => {
                setLoadingSave(false);
            });
    }

    if (props.showNotesForm) {
        return <>
            <Grid sx={{ backgroundColor: blackcolor, textAlign: "center", padding: "0px", maxHeight: "605px" }} container>
                <Grid item xs={8}>
                    <video controls src={props.video.s3TempPath} style={{ width: "100%", minHeight: "600px", maxHeight: "600px" }}></video>
                </Grid>
                <Grid item xs={4}>
                    <Box sx={{ background: "rgb(242, 238, 228)", height: "100%", padding: "10px" }}>
                        <Card variant="outlined" style={{ padding: "15px 10px 15px 10px", height: "150px", marginBottom: "10px" }}>
                            <label style={{ color: pcolor, fontWeight: "bold", display: "block", textAlign: "left" }}>Notes</label>
                            <TextField variant="outlined" placeholder="Write your observations here." fullWidth inputProps={{ maxLength: 1000 }}
                                value={note} onChange={(e) => {
                                    setNote(e.target.value);
                                }} />
                            <Box style={{ textAlign: "right", marginTop: "10px" }}>
                                {loadingSave ? <CircularProgress /> : <Button type="button" sx={buttonRed}
                                    disabled={loadingSave} style={{ width: 40 }} onClick={() => { saveData(); }}>Post</Button>}
                            </Box>
                            {errorSave !== "" ? <Box><Typography style={{ color: "red" }}>{errorSave}</Typography></Box> : null}
                        </Card>
                        <Box style={{ maxHeight: "calc(605px - 180px)", overflowY: "auto", paddingRight: "5px" }}>
                            {loading ? <Box style={{ textAlign: "center", padding: "10px" }}>
                                <CircularProgress />
                            </Box> : null}
                            {notes.map((item, index) => {
                                return <Card key={index} variant="outlined" style={{ padding: "15px 10px 15px 10px", marginTop: "15px", textAlign: "left" }}>
                                    <Box><Typography sx={{ textAlign: "justify" }}>{item.note}</Typography></Box>
                                    <Grid container>
                                        <Grid item xs={11}>
                                            <Box sx={{ ...fsSmall, marginTop: "15px" }}>
                                                Posted by {item.professionalName} on {dayjs(item.createdAt).format('DD/MM/YY')}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={1}>
                                            {ls.getLoggedInEmail() == item.professionalEmail ? <IconButton disabled={loadingSave} aria-label="delete" onClick={() => {
                                                if (window.confirm("You cannot revert this operation? Do you wish to continue")) {
                                                    removeData(item.id);
                                                }
                                            }}>
                                                <DeleteIcon />
                                            </IconButton> : null}
                                        </Grid>
                                    </Grid>


                                </Card>
                            })}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </>;
    } else
        return <Grid sx={{ backgroundColor: blackcolor, textAlign: "center", padding: "10px" }}>
            <video controls src={props.video.s3TempPath} style={{ width: "100%", height: "600px" }}></video>
        </Grid>;
}